import {defineStore} from "pinia";
import axios from "axios";

export const SessionCategoriesStore = defineStore("categories", {
    state: () => ({
        sessionCategories: null,
    }),
    actions: {
        async getSessionCategories() {
            return new Promise(async (resolve, reject) => {
                if (this.sessionCategories !== null) {
                    resolve(this.sessionCategories);
                    return;
                }

                try {
                    const response = await axios.get("/wp-json/categories/v1/category-list/");
                    this.sessionCategories = response.data;
                    resolve(this.sessionCategories);
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
});